module.exports = __webpack_public_path__ + "img/aries.30b54364.svg";